import './theme/main.scss';

import debug from 'debug';
const log = debug('app:startup');

import './containers/common';
import './containers/user-management';
import "./containers/profiles-export";
import './config/dt-control-buttons';

import './components/datatable/buttons/excelExport';

import './compat/datatables-fixedheader';
import './compat/select2';
import './compat/toastr';
import './compat/sweetalert';

import { initialize, store, loadLocale } from './compat/core';

import createStore from './config/store';
store.set(createStore());

// register all required initializers
import initializers from './config/initializers';
initialize.register(initializers);
import finalizers from './config/finalizers';
initialize.register(finalizers, true);

import customTemplates from './config/table-templates';
import customCallbacks from './config/table-callbacks';
import './config/table-renderers';
import ckeditorTemplates from './config/ck-editor-templates';

ckeditorTemplates(); //set templates for ck-editor

import $ from 'jquery';
// trigger first initialization on document ready
$(function () {
    loadLocale().then(() => {
        customTemplates();
        customCallbacks();
        initialize.trigger();
    });

    window.scrollUp = function () {
        log('scroll up');
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
});

// trigger initializers on modal loaded
$(document).on('loaded.bs.modal', function (e) {
    initialize.trigger(e.target);
});
$(document).on('hidden.bs.modal', '[data-remote-content]', function (e) {
    $(e.target).removeData('bs.modal');
});
